export enum mecansimTypesEnum {
  TOGGLE_EDIT_ONE_SHOT = 'TOGGLE_EDIT_ONE_SHOT',
  TOGGLE_EDIT_EXAM = 'TOGGLE_EDIT_EXAM',
  TOGGLE_EDIT_CERTIFICATE = 'TOGGLE_EDIT_CERTIFICATE',
  TOGGLE_EDIT_CYCLE = 'TOGGLE_EDIT_CYCLE',
  RESET_ALL = 'RESET_ALL',
}
